import { render, staticRenderFns } from "./CoreClientForm.vue?vue&type=template&id=89ffc4fc&scoped=true&"
import script from "./CoreClientForm.vue?vue&type=script&lang=js&"
export * from "./CoreClientForm.vue?vue&type=script&lang=js&"
import style0 from "./CoreClientForm.vue?vue&type=style&index=0&id=89ffc4fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ffc4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ffc4fc')) {
      api.createRecord('89ffc4fc', component.options)
    } else {
      api.reload('89ffc4fc', component.options)
    }
    module.hot.accept("./CoreClientForm.vue?vue&type=template&id=89ffc4fc&scoped=true&", function () {
      api.rerender('89ffc4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Cores/Client/Profile/CoreClientForm.vue"
export default component.exports